export const MyOrderSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="28.98"
		height="33.99"
		viewBox="0 0 38.575 42.581"
		fill="#2C2C2C"
	>
		<path
			id="box"
			d="M96.713,43.318,83.287,51.085,69.861,43.318,82.313,36.2A1.988,1.988,0,0,1,83,35.964a1.9,1.9,0,0,1,1.261.239ZM82.373,74.434a1.937,1.937,0,0,0,1.836,0,5.876,5.876,0,0,0,1.962-.694l13.5-7.717a5.763,5.763,0,0,0,2.505-2.92,5.877,5.877,0,0,0,.4-2.091V45.578a5.749,5.749,0,0,0-.606-2.573,1.956,1.956,0,0,0-.488-.8c-.06-.083-.123-.166-.187-.245a5.853,5.853,0,0,0-1.6-1.379L86.173,32.853a5.765,5.765,0,0,0-3.769-.7,5.865,5.865,0,0,0-2,.7L66.9,40.568a5.788,5.788,0,0,0-1.815,1.639,1.958,1.958,0,0,0-.484.8c-.077.154-.147.314-.208.474A5.921,5.921,0,0,0,64,45.565V61.008a5.754,5.754,0,0,0,1.281,3.622,5.854,5.854,0,0,0,1.6,1.379L80.4,73.734a5.7,5.7,0,0,0,1.971.7ZM81.359,54.425V69.838L68.832,62.68a2,2,0,0,1-.55-.473,1.891,1.891,0,0,1-.424-1.2V46.616Zm3.857,15.412V54.425l13.5-7.809V61.008a2,2,0,0,1-.135.7,1.9,1.9,0,0,1-.822.964Z"
			transform="translate(-64 -32.082)"
		/>
	</svg>
);

export const ReturnsSvg = ({
	width = '32.99',
	height = '34.99',
	viewBox = '0 0 42.582 42.581',
}: {
	width?: string;
	height?: string;
	viewBox?: string;
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={width}
		height={height}
		viewBox={viewBox}
		fill="#2C2C2C"
		stroke="#2C2C2C"
		id="returns-svg"
	>
		<g id="Grupo_18058" data-name="Grupo 18058" transform="translate(-20 -1354.041)">
			<g id="Grupo_1970" data-name="Grupo 1970" transform="translate(20 1354.041)">
				<g id="Grupo_46" data-name="Grupo 46" transform="translate(12.593 12.171)">
					<path
						id="Trazado_37"
						data-name="Trazado 37"
						d="M717.995-321.463a.774.774,0,0,0-.026-.189.707.707,0,0,0-.031-.075.83.83,0,0,0-.047-.113.706.706,0,0,0-.052-.068.759.759,0,0,0-.072-.094.779.779,0,0,0-.068-.052.781.781,0,0,0-.092-.071l0,0,0,0-7.453-4.217a.784.784,0,0,0-.773,0l-3.608,2.043h0l-3.844,2.173,0,0,0,0a.762.762,0,0,0-.089.069.753.753,0,0,0-.07.054.743.743,0,0,0-.074.1.7.7,0,0,0-.049.065.759.759,0,0,0-.052.123.647.647,0,0,0-.027.065.767.767,0,0,0-.024.182c0,.007,0,.014,0,.022v8.826a.784.784,0,0,0,.4.683l7.453,4.217a.777.777,0,0,0,.125.051c.02.008.04.019.061.025a.777.777,0,0,0,.2.027.786.786,0,0,0,.2-.026c.021-.005.04-.017.061-.025a.76.76,0,0,0,.125-.051l7.453-4.217a.784.784,0,0,0,.4-.683v-8.826C718-321.453,717.995-321.457,717.995-321.463Zm-8.236-3.3,5.86,3.316L713.6-320.3l-5.86-3.316Zm-.785,15.013-5.884-3.329V-320.1l5.884,3.332Zm.785-8.379-5.86-3.319,2.25-1.272,5.861,3.316Zm6.669,5.05-5.884,3.329v-7.019l5.884-3.332Z"
						transform="translate(-701.521 326.448)"
						stroke-width="0.4"
					/>
				</g>
				<g id="Grupo_49" data-name="Grupo 49">
					<g id="Grupo_48" data-name="Grupo 48">
						<path
							id="Trazado_38"
							data-name="Trazado 38"
							d="M634.738-415.609a1.775,1.775,0,0,0-1.774,1.774v1.479a20.963,20.963,0,0,0-13.851-5.175,21.242,21.242,0,0,0-21.18,21.255,1.775,1.775,0,0,0,1.774,1.774,1.775,1.775,0,0,0,1.774-1.774,17.689,17.689,0,0,1,17.632-17.707,17.452,17.452,0,0,1,11.428,4.222h-1.626a1.775,1.775,0,0,0-1.774,1.774,1.775,1.775,0,0,0,1.774,1.774h5.823a1.775,1.775,0,0,0,1.774-1.774v-5.848A1.775,1.775,0,0,0,634.738-415.609Z"
							transform="translate(-597.933 417.531)"
						/>
					</g>
				</g>
				<g id="Grupo_51" data-name="Grupo 51" transform="translate(4.189 19.552)">
					<g id="Grupo_50" data-name="Grupo 50">
						<path
							id="Trazado_39"
							data-name="Trazado 39"
							d="M670.016-252a1.775,1.775,0,0,0-1.774,1.774,17.689,17.689,0,0,1-17.631,17.707,17.45,17.45,0,0,1-11.319-4.125H641a1.775,1.775,0,0,0,1.774-1.774A1.775,1.775,0,0,0,641-240.192h-5.824c-.016,0-.031,0-.045,0a1.752,1.752,0,0,0-.2.02c-.05.007-.1.012-.148.023s-.116.035-.174.054-.107.035-.159.058-.095.051-.142.077-.111.063-.163.1c-.013.01-.028.015-.042.026-.03.023-.053.051-.081.076a1.656,1.656,0,0,0-.137.128,1.709,1.709,0,0,0-.109.132c-.035.045-.068.091-.1.139s-.058.1-.083.153a1.644,1.644,0,0,0-.07.155,1.728,1.728,0,0,0-.051.167,1.676,1.676,0,0,0-.038.164,1.9,1.9,0,0,0-.019.19c0,.036-.011.072-.011.109v5.848a1.775,1.775,0,0,0,1.774,1.774,1.775,1.775,0,0,0,1.774-1.774v-1.411a20.971,20.971,0,0,0,13.664,5.01,21.242,21.242,0,0,0,21.18-21.255A1.775,1.775,0,0,0,670.016-252Z"
							transform="translate(-633.398 252)"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);

export const ShippingDeliveriesSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="38.31"
		height="35.31"
		viewBox="0 0 47.356 40.955"
		fill="#2C2C2C"
		stroke="#2C2C2C"
		id="shipping-deliveries-svg"
	>
		<g id="Grupo_18057" data-name="Grupo 18057" transform="translate(-19.953 -1397.674)">
			<g id="Grupo_1841" data-name="Grupo 1841" transform="translate(20.203 1397.674)">
				<g id="Grupo_55" data-name="Grupo 55" transform="translate(7.909 0)">
					<g id="Grupo_54" data-name="Grupo 54">
						<path
							id="Trazado_40"
							data-name="Trazado 40"
							d="M1070.351-423.581a.222.222,0,0,0-.007-.025,1.788,1.788,0,0,0-.116-.348c-.006-.014-.008-.03-.014-.043l-3.6-7.5a1.629,1.629,0,0,0-1.46-.942h-5.467a11.506,11.506,0,0,0,1.874-6.314,11.02,11.02,0,0,0-10.771-11.228,11,11,0,0,0-10.758,10.938h-7.207a1.671,1.671,0,0,0-1.633,1.707v5.057h3.267v-3.352h5.984c.027.1.065.2.095.294.039.127.079.255.123.38.064.181.132.358.2.534.048.118.094.236.146.351.082.181.171.358.26.535.053.1.1.209.158.31.106.193.222.38.338.565.049.078.094.158.145.234a11.3,11.3,0,0,0,1.15,1.459c.063.068.132.131.2.2.149.153.3.3.458.448.086.079.177.151.264.226.145.123.29.245.44.36.1.077.2.147.3.22.147.106.295.209.447.306.109.07.219.136.331.2.152.09.3.176.46.258.116.062.233.121.351.178.157.076.318.147.48.215.12.051.24.1.363.147.167.064.336.121.506.175.123.04.243.08.366.115.18.05.362.091.544.132.118.026.237.055.355.078.2.037.411.064.617.09.1.013.2.031.3.041.31.029.624.045.94.045.348,0,.694-.019,1.037-.053.113-.012.226-.033.339-.049.192-.026.385-.045.576-.082v10.234h-7.779c-.022-.02-.049-.035-.071-.055a4.843,4.843,0,0,0-.614-.491l-.021-.013a4.653,4.653,0,0,0-.677-.357c-.043-.018-.086-.039-.129-.056a4.512,4.512,0,0,0-.723-.219c-.048-.011-.1-.018-.145-.027a4.377,4.377,0,0,0-.785-.079,4.437,4.437,0,0,0-.782.078c-.055.011-.111.02-.167.032a4.516,4.516,0,0,0-.725.22c-.039.016-.075.035-.114.051a4.6,4.6,0,0,0-.613.323c-.039.024-.08.047-.119.072a4.676,4.676,0,0,0-.6.478c-.017.016-.038.028-.055.044h-4.168v-2.532h-3.267v4.238a1.671,1.671,0,0,0,1.633,1.707h4.309c0,.058-.013.113-.013.171a4.783,4.783,0,0,0,4.678,4.872,4.779,4.779,0,0,0,4.671-4.872c0-.057-.011-.113-.012-.171H1056.9c0,.058-.012.113-.012.171a4.78,4.78,0,0,0,4.671,4.872,4.784,4.784,0,0,0,4.679-4.872c0-.058-.013-.113-.014-.171h2.528a1.672,1.672,0,0,0,1.634-1.707v-7.457A1.714,1.714,0,0,0,1070.351-423.581ZM1041.8-412.438a1.436,1.436,0,0,1-1.412-1.459,1.438,1.438,0,0,1,.267-.85,1.354,1.354,0,0,1,.512-.444,1.413,1.413,0,0,1,1.755.422l.067.09a1.48,1.48,0,0,1,.216.782A1.434,1.434,0,0,1,1041.8-412.438Zm19.591-16.587h2.756l1.962,4.087h-4.718Zm-7.647-2.545a7.315,7.315,0,0,1-2.144.578,7.254,7.254,0,0,1-.809.047,7.653,7.653,0,0,1-7.425-6.646,8.235,8.235,0,0,1-.079-1.162,7.673,7.673,0,0,1,7.5-7.816,7.676,7.676,0,0,1,7.506,7.817,7.826,7.826,0,0,1-3.469,6.577A6.867,6.867,0,0,1,1053.74-431.569Zm7.819,19.132a1.434,1.434,0,0,1-1.406-1.458,1.444,1.444,0,0,1,.268-.851c.031-.044.069-.077.1-.116a1.4,1.4,0,0,1,2.165.095,1.46,1.46,0,0,1,.283.871A1.437,1.437,0,0,1,1061.56-412.438Zm5.561-5.043h-2.39c-.011-.011-.026-.018-.038-.03a4.692,4.692,0,0,0-.633-.5c-.022-.015-.045-.027-.067-.042a4.506,4.506,0,0,0-.667-.351c-.029-.013-.056-.028-.086-.039a4.435,4.435,0,0,0-.737-.224l-.161-.03a4.457,4.457,0,0,0-.784-.078,4.417,4.417,0,0,0-.78.078c-.055.011-.11.02-.166.032a4.525,4.525,0,0,0-.725.22c-.038.016-.074.035-.112.051a4.74,4.74,0,0,0-.613.323c-.038.026-.08.047-.117.072a4.6,4.6,0,0,0-.6.479c-.017.016-.037.027-.053.043h-2.39v-11.454c.05-.03.1-.059.15-.09h1.966v5.793a1.671,1.671,0,0,0,1.633,1.706h7.366Z"
							transform="translate(-1031.19 449.98)"
						/>
					</g>
				</g>
				<g id="Grupo_57" data-name="Grupo 57" transform="translate(0 18.776)">
					<g id="Grupo_56" data-name="Grupo 56">
						<path
							id="Trazado_41"
							data-name="Trazado 41"
							d="M979.011-269.234H963.379a2.195,2.195,0,0,0-2.194,2.194,2.195,2.195,0,0,0,2.194,2.194h15.632a2.195,2.195,0,0,0,2.194-2.194A2.194,2.194,0,0,0,979.011-269.234Z"
							transform="translate(-961.185 269.234)"
							stroke="#fff"
							stroke-width="0.5"
						/>
					</g>
				</g>
				<g id="Grupo_59" data-name="Grupo 59" transform="translate(3.625 24.13)">
					<g id="Grupo_58" data-name="Grupo 58">
						<path
							id="Trazado_42"
							data-name="Trazado 42"
							d="M1001.818-217.7H989.811a2.195,2.195,0,0,0-2.194,2.194,2.195,2.195,0,0,0,2.194,2.194h12.007a2.194,2.194,0,0,0,2.194-2.194A2.195,2.195,0,0,0,1001.818-217.7Z"
							transform="translate(-987.617 217.698)"
							stroke="#fff"
							stroke-width="0.5"
						/>
					</g>
				</g>
				<line
					id="Línea_1"
					data-name="Línea 1"
					y1="15.771"
					transform="translate(9.564 15.539)"
					fill="none"
				/>
				<path
					id="shipping-deliveries-svg-flag"
					data-name="Trazado 43"
					d="M1186.461-364.346l2.53,2.22,5.382-5.166"
					transform="translate(-1162.575 375.736)"
					fill="none"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="2.4"
				/>
			</g>
		</g>
	</svg>
);

export const PaymentMethodsSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="39.97"
		height="35.31"
		viewBox="0 0 49.445 41.255"
		fill="#2C2C2C"
		stroke="#fff"
	>
		<g id="Grupo_18059" data-name="Grupo 18059" transform="translate(-19.85 -1444.765)">
			<g id="Grupo_1968" data-name="Grupo 1968" transform="translate(20 1444.915)">
				<g id="Grupo_35" data-name="Grupo 35" transform="translate(0 0)">
					<g id="Grupo_34" data-name="Grupo 34" transform="translate(0 0)">
						<path
							id="Trazado_32"
							data-name="Trazado 32"
							d="M196.282-376.978h-45.05a2.05,2.05,0,0,0-2.048,2.051v23.794a2.05,2.05,0,0,0,2.048,2.051h45.05a2.05,2.05,0,0,0,2.048-2.051v-23.794A2.05,2.05,0,0,0,196.282-376.978Zm-26.641,17.527a2.05,2.05,0,0,0-2.048,2.051,2.05,2.05,0,0,0,2.048,2.051h2.068v2.164H153.28v-19.692H171.71v2.174h-.031a4.92,4.92,0,0,0-4.966,4.861,4.92,4.92,0,0,0,4.966,4.861h4.167a.829.829,0,0,1,.86.769.826.826,0,0,1-.86.759h-6.2Zm24.593,6.266H175.805v-2.164h.041a4.941,4.941,0,0,0,4.854-3.883,4.734,4.734,0,0,0,.1-.978,4.76,4.76,0,0,0-.1-.98,4.944,4.944,0,0,0-4.854-3.891h-4.167a.831.831,0,0,1-.87-.759.821.821,0,0,1,.87-.759h6.194a2.05,2.05,0,0,0,2.048-2.051,2.05,2.05,0,0,0-2.048-2.051h-2.068v-2.174h18.429Z"
							transform="translate(-149.185 376.978)"
							stroke-width="0.3"
						/>
					</g>
				</g>
				<g id="Grupo_37" data-name="Grupo 37" transform="translate(0 29.439)">
					<g id="Grupo_36" data-name="Grupo 36" transform="translate(0 0)">
						<path
							id="Trazado_33"
							data-name="Trazado 33"
							d="M196.282-139.9h-45.05a2.373,2.373,0,0,0-2.048,2.6,2.373,2.373,0,0,0,2.048,2.6h45.05a2.373,2.373,0,0,0,2.048-2.6A2.373,2.373,0,0,0,196.282-139.9Z"
							transform="translate(-149.185 139.898)"
							stroke-width="0.3"
						/>
					</g>
				</g>
				<g id="Grupo_39" data-name="Grupo 39" transform="translate(0 35.76)">
					<g id="Grupo_38" data-name="Grupo 38" transform="translate(0 0)">
						<path
							id="Trazado_34"
							data-name="Trazado 34"
							d="M196.282-88.978h-45.05a2.373,2.373,0,0,0-2.048,2.6,2.373,2.373,0,0,0,2.048,2.6h45.05a2.373,2.373,0,0,0,2.048-2.6A2.373,2.373,0,0,0,196.282-88.978Z"
							transform="translate(-149.185 88.978)"
							stroke-width="0.3"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
);

export const HowToBuySvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="32.88"
		height="34.91"
		viewBox="0 0 42.462 42.501"
		fill="#2C2C2C"
	>
		<path
			id="shopping_cart_FILL0_wght400_GRAD0_opsz24"
			d="M52.75-837.5a4.093,4.093,0,0,1-3-1.248,4.093,4.093,0,0,1-1.248-3,4.093,4.093,0,0,1,1.248-3,4.093,4.093,0,0,1,3-1.248,4.093,4.093,0,0,1,3,1.248,4.093,4.093,0,0,1,1.248,3,4.093,4.093,0,0,1-1.248,3A4.093,4.093,0,0,1,52.75-837.5Zm21.25,0a4.093,4.093,0,0,1-3-1.248,4.093,4.093,0,0,1-1.248-3,4.093,4.093,0,0,1,1.248-3A4.093,4.093,0,0,1,74-846a4.093,4.093,0,0,1,3,1.248,4.093,4.093,0,0,1,1.248,3,4.093,4.093,0,0,1-1.248,3A4.093,4.093,0,0,1,74-837.5Zm-23.057-34,5.1,10.625H70.919L76.763-871.5Zm-2.019-4.25H80.27a2.034,2.034,0,0,1,1.859,1.089,2.142,2.142,0,0,1,.053,2.2l-7.544,13.6a4.256,4.256,0,0,1-1.567,1.647,4.133,4.133,0,0,1-2.152.584H55.088l-2.338,4.25H76.126a2.056,2.056,0,0,1,1.514.611,2.056,2.056,0,0,1,.611,1.514,2.056,2.056,0,0,1-.611,1.514,2.056,2.056,0,0,1-1.514.611H52.75a3.934,3.934,0,0,1-3.613-2.1,4.017,4.017,0,0,1-.106-4.17L51.9-859.6l-7.65-16.15H42.125a2.056,2.056,0,0,1-1.514-.611A2.056,2.056,0,0,1,40-877.875a2.056,2.056,0,0,1,.611-1.514A2.056,2.056,0,0,1,42.125-880h3.453a2.136,2.136,0,0,1,1.116.319,1.981,1.981,0,0,1,.8.9Zm7.119,14.875h0Z"
			transform="translate(-40 880)"
		/>
	</svg>
);

export const MyAccountSvg = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="32.91"
		height="34.91"
		viewBox="0 0 42.501 42.501"
		fill="#2C2C2C"
	>
		<path
			id="person_FILL0_wght400_GRAD0_opsz24_2_"
			data-name="person_FILL0_wght400_GRAD0_opsz24 (2)"
			d="M181.25-778.75a10.232,10.232,0,0,1-7.5-3.121,10.231,10.231,0,0,1-3.121-7.5,10.231,10.231,0,0,1,3.121-7.5,10.231,10.231,0,0,1,7.5-3.121,10.231,10.231,0,0,1,7.5,3.121,10.231,10.231,0,0,1,3.121,7.5,10.231,10.231,0,0,1-3.121,7.5A10.231,10.231,0,0,1,181.25-778.75ZM160-762.812v-2.125a7.781,7.781,0,0,1,1.162-4.15,7.746,7.746,0,0,1,3.088-2.889,39.436,39.436,0,0,1,8.367-3.088,36.544,36.544,0,0,1,8.633-1.029,36.544,36.544,0,0,1,8.633,1.029,39.436,39.436,0,0,1,8.367,3.088,7.746,7.746,0,0,1,3.088,2.889,7.781,7.781,0,0,1,1.162,4.15v2.125a5.116,5.116,0,0,1-1.561,3.752,5.116,5.116,0,0,1-3.752,1.561H165.313a5.116,5.116,0,0,1-3.752-1.561A5.116,5.116,0,0,1,160-762.812Zm5.313,0h31.876v-2.125a2.5,2.5,0,0,0-.365-1.328,2.585,2.585,0,0,0-.963-.93,34.627,34.627,0,0,0-7.238-2.69,30.815,30.815,0,0,0-7.371-.9,30.815,30.815,0,0,0-7.371.9,34.627,34.627,0,0,0-7.238,2.69,2.585,2.585,0,0,0-.963.93,2.5,2.5,0,0,0-.365,1.328Zm15.938-21.25A5.116,5.116,0,0,0,185-785.623a5.116,5.116,0,0,0,1.561-3.752A5.116,5.116,0,0,0,185-793.127a5.116,5.116,0,0,0-3.752-1.561,5.116,5.116,0,0,0-3.752,1.561,5.116,5.116,0,0,0-1.561,3.752,5.116,5.116,0,0,0,1.561,3.752A5.116,5.116,0,0,0,181.25-784.062ZM181.25-789.375ZM181.25-762.812Z"
			transform="translate(-160 800)"
		/>
	</svg>
);
